var exports = {
  "kL": "MatureContentChannelGate.module__container___VnE2SV",
  "Qs": "MatureContentChannelGate.module__content___VnE2SV",
  "DD": "MatureContentChannelGate.module__title___VnE2SV",
  "h_": "MatureContentChannelGate.module__description___VnE2SV",
};

module.exports = exports;
